export const PASSWORD_RECOVER_SUCCESS = 'PASSWORD_RECOVER_SUCCESS';
export const PASSWORD_RECOVER_FAILURE = 'PASSWORD_RECOVER_FAILURE';
